import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const Axios = axios.create({
  baseURL: `${api}`,
  timeout: 10000,
  headers: {
    Authorization: "Bearer " + sessionStorage.getItem("SSOToken"),
  },
});
